<template>
  <component
    :is="tag"
    :href="href"
    v-bind="$attrs"
    @click="onClick"
  >
    <slot />
  </component>
</template>

<script>
const MTS_HOST_SUFFIX = 'mts.ru'

export default {
  name: 'ExternalLink',
  inheritAttrs: false,
  props: {
    href: {
      type: String,
      required: true,
    },
    tag: {
      type: String,
      default: 'a',
    },
  },
  computed: {
    isExternal() {
      if (!this.href || this.href.startsWith('/') || this.href.startsWith('#')) {
        return false
      }

      try {
        const url = new URL(this.href, window.location.origin)

        return !url.hostname.endsWith(MTS_HOST_SUFFIX) && url.hostname !== window.location.hostname
      } catch (e) {
        return false
      }
    },
  },
  methods: {
    onClick(event) {
      if (!this.isExternal) {
        return
      }

      event.preventDefault()

      if (window.confirm('Вы переходите на внешний сайт. Продолжить?')) {
        window.open(this.href, '_blank', 'noopener,noreferrer')
      }
    },
  },
}
</script>
